import {memo} from 'react';
import style from './style.module.scss';
import {TArticlePreview} from 'modules/blog/types';
import {Typography} from 'components/Typography';
import ArticleViews from 'modules/blog/components/ArticleViews';
import {getMediaSrc} from 'core/helpers/media';
import classNames from 'classnames';
import Link from 'components/CustomRoutingLink';

interface IArticleCardProps {
    article: TArticlePreview;
    to: TArticlePreview['url'];
    category?: string;
    id?: number;
    onArticleClick?: () => void;
}

// eslint-disable-next-line complexity
export const ArticleCard = memo<IArticleCardProps>(({article, to, id, category, onArticleClick}) => {
    const {title, readingCounter, preview} = article;

    const handleClick = () => {
        sessionStorage.setItem('scrollY', String(window.scrollY));
        onArticleClick?.();
    };

    return (
        <Link
            className={classNames(style.linkWrapper, 'article-card')}
            href={article.link || article.url || to || ''}
            legacyBehavior={true}
            passHref={true}
        >
            <a
                data-autotest-target={`blog-main-category${category ? `-${category}` : ''}`}
                data-autotest-target-id={`blog-main-category${category ? `-${category}` : ''}-${id ?? article.id}`}
                onClick={handleClick}
            >
                <div className={style.articleCard}>
                    <div className={style.imgWrap}>
                        <div className={style.inner}>
                            {preview && (
                                <img
                                    alt={title || ''}
                                    className={style.img}
                                    src={getMediaSrc(preview.imageUrl || '', {width: 874, isWebp: true})}
                                />
                            )}
                        </div>
                    </div>
                    <div className={style.infoWrapper}>
                        <Typography
                            className={classNames(style.text, 'article-card__name')}
                            data-autotest-target={'blog-main-article-title'}
                            data-autotest-target-id={`blog-main-article-title-${id ?? article.id}`}
                            variant={'ch-title-20-reg'}
                        >
                            {title}
                        </Typography>
                        <ArticleViews count={readingCounter as number} />
                    </div>
                </div>
            </a>
        </Link>
    );
});
